import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Radio, Typography } from 'antd';
import moment from 'moment';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { FC } from 'react';

const { Text } = Typography;

interface CustomerProps {
  name: string;
  birthDate: string | null;
  phone: string | null;
  email: string | null;
  isPhoneVerified: boolean;
  branches: string | null;
  id: number;
}

export const WriteFirstModalSimilarCustomer: FC<CustomerProps> = ({
  name,
  birthDate,
  phone,
  email,
  isPhoneVerified,
  branches,
  id,
}) => {
  return (
    <div className="gray-round-border similar-customer">
      <Radio className="similar-customer-radio" value={id} />
      <div className="similar-customer-text">
        <Text strong>{name}</Text>
        <Text>
          {birthDate ? `, ${moment(birthDate).format('DD.MM.YYYY')}` : ''}
        </Text>
        <br />
        {isPhoneVerified && (
          <FontAwesomeIcon
            icon={'fa-solid fa-circle-check' as IconProp}
            className="phone-icon-checked"
          />
        )}
        <Text>{`${phone ? phone : ''}${email ? `, ${email}` : ''}`}</Text>
        {branches ? (
          <>
            <br />
            <FontAwesomeIcon
              icon={'fa-solid fa-location-dot' as IconProp}
              className="location-icon"
            />
            <Text>{branches}</Text>
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
